import { render, staticRenderFns } from "./IvestorBetaForm.vue?vue&type=template&id=9b959aea"
import script from "./IvestorBetaForm.vue?vue&type=script&lang=js"
export * from "./IvestorBetaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CountryDropdown: require('/vercel/path0/components/ui/CountryDropdown.vue').default,InfoBox: require('/vercel/path0/components/InfoBox.vue').default})
